import React, { useState } from 'react';

const initialUsers = [
  { id: 1, name: 'Alice Kimani', email: 'alice@example.com', role: 'Viewer' },
  { id: 2, name: 'Brian Otieno', email: 'brian@example.com', role: 'Editor' },
  { id: 3, name: 'Cynthia Mwangi', email: 'cynthia@example.com', role: 'Admin' },
];

const roles = ['Viewer', 'Editor', 'Admin'];

const ManageUsersComponent = () => {
  const [users, setUsers] = useState(initialUsers);
  const [searchTerm, setSearchTerm] = useState('');

  const handleRoleChange = (id, newRole) => {
    setUsers(prev =>
      prev.map(user => (user.id === id ? { ...user, role: newRole } : user))
    );
  };

  const handleDelete = id => {
    setUsers(prev => prev.filter(user => user.id !== id));
  };

  const handleUpdate = () => alert("Implememt update action")

  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-4xl mx-auto p-4 bg-white rounded shadow">
      <h2 className="text-2xl font-semibold mb-4">Manage Users</h2>

      {/* Search Input */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by name or email"
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>

      {/* User Table */}
      <table className="w-full table-auto border border-gray-200">
        <thead className="bg-gray-100 text-left">
          <tr>
            <th className="px-4 py-2 border-b">Name</th>
            <th className="px-4 py-2 border-b">Email</th>
            <th className="px-4 py-2 border-b">Role</th>
            <th className="px-4 py-2 border-b">Actions</th>
            <th className="px-4 py-2 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map(user => (
            <tr key={user.id} className="border-t">
              <td className="px-4 py-2">{user.name}</td>
              <td className="px-4 py-2">{user.email}</td>
              <td className="px-4 py-2">
                <select
                  value={user.role}
                  onChange={e => handleRoleChange(user.id, e.target.value)}
                  className="border border-gray-300 rounded px-2 py-1"
                >
                  {roles.map(role => (
                    <option key={role} value={role}>
                      {role}
                    </option>
                  ))}
                </select>
              </td>
              <td className="px-4 py-2">
                <button
                  onClick={() => handleDelete(user.id)}
                  className="text-red-600 hover:underline text-sm"
                >
                  Delete
                </button>
              </td>
                <td className="px-4 py-2">
                <button
                  onClick={() => handleUpdate(user.id)}
                  className="text-red-600 hover:underline text-sm"
                >
                  Update
                </button>
              </td>
            </tr>
          ))}
          {filteredUsers.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center text-gray-500 py-4">
                No matching users found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ManageUsersComponent;
